import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import MemberItem from "./MemberItem";
import { getWindowDimension } from "../../../utils/getWindowDimension";

export default function WrapperList({
  title,
  name,
  collection,
  mobileBlockChange,
  controllerName,
  currentUserType,
}) {
  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "",
    //padding: grid,
    //width: 250
  });

  const getItemStyle = (isDragging, draggableStyle) => ({
    border: isDragging ? "1px solid #686868" : "",
    // styles we need to apply on draggables
    ...draggableStyle,
    boxSizing: "content-box",
  });

  const { width, height } = getWindowDimension();

  return (
    <div
      className={
        name == "memberListActive" ? "active-members" : "archive-members"
      }
    >
      <h1 className="header-title">{title}</h1>
      {name == "memberListActive" && (
        <a href="#" className="btn btn-link close-contact-list">
          X
        </a>
      )}
      <hr />
      <Droppable droppableId={name}>
        {(provided, snapshot) => (
          <ul
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {collection.length == 0 && (
              <div className="empty-block">
                {name == "memberListActive"
                  ? `There are no ${
                      currentUserType == "coach" ? "members" : "coaches"
                    } here`
                  : `There are no archived ${
                      currentUserType == "coach" ? "members" : "coaches"
                    }`}
              </div>
            )}
            {collection.map((sessionRoom, index) => (
              <Draggable
                key={parseInt(sessionRoom.id)}
                draggableId={sessionRoom.id}
                index={index}
                isDragDisabled={width <= 991}
              >
                {(provided, snapshot) => (
                  <MemberItem
                    name={name}
                    index={index}
                    sessionRoom={sessionRoom}
                    mobileBlockChange={mobileBlockChange}
                    controllerName={controllerName}
                    currentUserType={currentUserType}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    key={`right-member-list-${sessionRoom.id}`}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </div>
  );
}
